import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => {
    setIsOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  // Close mobile menu when switching to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        setIsOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Prevent background scrolling when mobile menu is open
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const links = [
    { to: '/', label: 'Home' },
    { to: '/en', label: 'Trending Blogs' },
    { to: '/products', label: 'Products' },
    { to: '/shorts', label: 'Shorts' },
    { to: '/privacy-policy', label: 'Privacy Policy' },
    { to: '/portfolio_to_website', label: 'PortfolioToWebsite' },
    { to: '/job_vacancy', label: 'JobVacancy' },
    { to: '/we_are_employees', label: 'WeAreEmployees' },
  ];

  return (
    <header className="dflux-header">
      <nav className="dflux-navbar">

        {/* BRAND */}
        <div className="dflux-brand-area">

          <NavLink
            to="/"
            className="dflux-brand-link"
            onClick={closeMenu}
            aria-label="DFLUXSPACE Home"
          >
            <span className="dflux-logo-wrap">
              <img
                src="/dfluxspace.png"
                width="40"
                height="40"
                alt="DFLUXSPACE"
                className="dflux-logo"
              />
            </span>

            <span className="dflux-brand-text">
              DFLUX<span>SPACE</span>
            </span>
          </NavLink>

          {/* MOBILE MENU BUTTON */}
          <button
            type="button"
            className={`dflux-toggler ${isOpen ? 'open' : ''}`}
            onClick={toggleNavbar}
            aria-label={
              isOpen
                ? 'Close navigation menu'
                : 'Open navigation menu'
            }
            aria-expanded={isOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

        </div>

        {/* NAVIGATION */}
        <div
          className={`dflux-menu ${isOpen ? 'active' : ''}`}
        >
          <ul className="dflux-nav-list">

            {links.map(({ to, label }) => (
              <li className="dflux-nav-item" key={to}>
                <NavLink
                  to={to}
                  end={to === '/'}
                  className={({ isActive }) =>
                    `dflux-nav-link ${
                      isActive ? 'active' : ''
                    }`
                  }
                  onClick={closeMenu}
                >
                  <span>{label}</span>
                </NavLink>
              </li>
            ))}

          </ul>
        </div>

        {/* MOBILE OVERLAY */}
        {isOpen && (
          <div
            className="dflux-menu-overlay"
            onClick={closeMenu}
            aria-hidden="true"
          />
        )}

      </nav>
    </header>
  );
};

export default Header;

